import React, {Component} from 'react';
import {Doughnut} from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Chart} from 'chart.js';
Chart.register(ChartDataLabels);

const options = {
	reponsive : true,
	maintainAspectRatio : false,
	cutoutPercentage :50,
	plugins: {
		datalabels:{
			color:'#fff',
			font : {
				family:'sans-serif',
				size:14,
				lineHeight : 1.6
			},
			formatter : function(value , context){
				return value + '%'
			}
		},
		legend: {
			display : false
		},
		tooltip: {
			enabled: false,
			// 커스텀 툴팁 생성(개발연동시 클래스명 확인)
			external: function (context) {
				// Tooltip Element
				var tooltipEl = document.getElementById('DoughnutChartToolTip');

				// Hide if no tooltip
				var tooltipModel = context.tooltip
				if (tooltipModel.opacity === 0) {
					tooltipEl.style.opacity = 0;
					return;
				}

				// Set caret Position
				tooltipEl.classList.remove('above', 'below', 'no-transform');
				if (tooltipModel.yAlign) {
					tooltipEl.classList.add(tooltipModel.yAlign);
				} else {
					tooltipEl.classList.add('no-transform');
				}

				function getBody(bodyItem) {
					return bodyItem.lines;
				}

				// Set Text
				if (tooltipModel.body) {
					var _html = '';

					_html += '<div class="tooltip-inner">';
					var bodyLines = tooltipModel.body.map(getBody);
					bodyLines.forEach(function (body, i) {
						var _body = String(body);
						var _title = _body.substring(0, _body.indexOf(':'));
						var _data = _body.substring(_body.indexOf(':') + 1, _body.length);
						var colors = tooltipModel.labelColors[i];
						_html += '<div class="tooltip-data-cell">';
						_html += '<div class="tooltip-bg" style="background-color:' + colors.borderColor + ';"></div>';
						_html += '<div class="tooltip-subject">' + _title + '</div>';
						_html += '<div class="tooltip-value">' + _data + '</div>';
						_html += '</div>';
					});
					_html += '</div>';

					tooltipEl.innerHTML = _html;
				}

				// `this` will be the overall tooltip
				var position = context.chart.canvas.getBoundingClientRect();

				//console.log(tooltipModel.caretX);

				// Display, position, and set styles for font
				tooltipEl.style.opacity = 1;
				tooltipEl.style.position = 'absolute';

				tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
				tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
				tooltipEl.style.pointerEvents = 'none';
				tooltipEl.style.pointerEvents = 'none';
			}
		}
	}
};

class DoughnutChart extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				labels: [],
				datasets: []
			}
		}
	}

	componentDidMount() {
		const record = this.props.record;

		let temp = this.state.data;
		temp.labels = record.labels
		temp.datasets.push({
			label: record.title,
			backgroundColor: record.color ? record.color : ['#40404f', '#837fcc', '#9baae8', '#bacbe9'],
			hoverBackgroundColor: record.color ? record.color : ['#40404f', '#837fcc', '#9baae8', '#bacbe9'],
			borderWidth: 0,
			data: record.data,
			datalabels: {
				anchor: 'center'
			}
		});

		this.setState({data: temp})
	}

	render() {
		return (
			<Doughnut data={this.state.data} options={options}/>
		)
	}
}

export default DoughnutChart;